import { useRouter } from 'next/router'
import { MembersTab as Layout, PEOPLE_TAB } from 'ui-components'

import { GuestList } from './GuestList'
import { MemberAccessTab } from './MemberAccessTab'
import { MemberList } from './MemberList'
import { MembersTabTools } from './MembersTabTools'

const Members = () => {
  const { query } = useRouter()

  return (
    <Layout
      currentTab={(query?.peopleTab as PEOPLE_TAB) || PEOPLE_TAB.MEMBERS}
      slots={{
        MemberAccessTab,
        MembersTabTools,
        MemberList,
        GuestList
      }}
    />
  )
}

export { Members }
